import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import styles from './GridItemArticle.module.scss'

export type GridArticleItemProps = {
  children: React.ReactNode
  className?: string
  area: GridArticleAreas
}

export const GridItemArticle: FunctionComponent<GridArticleItemProps> = ({
  className,
  area,
  children,
}) => <section className={classnames(styles[area], className)}>{children}</section>

export type GridArticleAreas =
  | 'author'
  | 'body'
  | 'date'
  | 'footer'
  | 'header'
  | 'hero'
  | 'jumplinks'
  | 'pageheader'
  | 'related'
  | 'share'
